import React from 'react';
import { useMutation } from 'react-query';
import { binderApi } from 'services/apis';
import { CreateBinderPayloadDto } from 'libs/pinnacle-sdk';
import { BinderForm } from '../new-binder-form';

const CreateBinderForm: React.FC = () => {
  const createBinderMutation = useMutation<
    void,
    Error,
    { binder: CreateBinderPayloadDto; fileIds: string[] }
  >(async ({ binder, fileIds }) => {
    await binderApi.createBinder({
      createBinderPayloadDto: {
        ...binder,
        fileIds,
      },
    });
  });

  return (
    <BinderForm
      mode="create"
      onSubmit={createBinderMutation.mutateAsync}
      isLoading={createBinderMutation.isLoading}
    />
  );
};

export default CreateBinderForm;
